import type { ReactNode } from 'react';
import { Box } from '@mui/material';

/** Rounded square with a module icon, in the space's colors. */
export function IconBadge({
  icon,
  tone = 'primary',
}: {
  icon: ReactNode;
  tone?: 'primary' | 'accent';
}) {
  return (
    <Box
      aria-hidden
      sx={(theme) => ({
        width: 48,
        height: 48,
        borderRadius: `${Math.min(Number(theme.shape.borderRadius) * 1.4, 16)}px`,
        display: 'grid',
        placeItems: 'center',
        bgcolor: theme.vars.palette[tone].container,
        color: theme.vars.palette[tone].onContainer,
      })}
    >
      {icon}
    </Box>
  );
}
